import React, { useState, useEffect } from 'react';

export const RegionContext = React.createContext();

function RegionProvider({ children }) {
  const [region, setUserRegion] = useState(null);
  const [fetchedAlertInfo, setFetchedAlertInfo] = useState({
    England: {
      RBC: 'NONE',
      PLT: 'NONE',
      FFP: 'NONE',
      CRYO: 'NONE',
    },
    Scotland: {
      RBC: 'NONE',
      PLT: 'NONE',
      FFP: 'NONE',
      CRYO: 'NONE',
    },
    Wales: {
      RBC: 'NONE',
      PLT: 'NONE',
      FFP: 'NONE',
      CRYO: 'NONE',
    },
    'Northern Ireland': {
      RBC: 'NONE',
      PLATELETS: 'NONE',
      FFP: 'NONE',
      CRYO: 'NONE',
    },
  });

  const regions = ['England', 'Northern Ireland', 'Scotland', 'Wales'];

  useEffect(() => {
    // get regional statuses json
    fetch(`/regionalStatuses.json`, {
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: 0,
      },
    })
      .then(response => response.json()) // parse JSON from request
      .then(data => {
        setFetchedAlertInfo(data);
      })
      .catch(error => {
        console.error('Could not fetch regional statuses:', error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RegionContext.Provider
      value={{
        region,
        regions,
        fetchedAlertInfo,
        setRegion: regionToSet => setUserRegion(regionToSet),
      }}>
      {children}
    </RegionContext.Provider>
  );
}

function useRegion() {
  const context = React.useContext(RegionContext);
  if (context === undefined) {
    // throw new Error('useRegion must be used within a RegionProvider');
  }
  return context;
}
export { RegionProvider, useRegion };

export default RegionProvider;
